<div>
  <div class="sidebar">

    <ng-container *ngFor="let module of sortByIndex(ADMIN_ROUTER | keyvalue); trackBy: trackByFn">

      <span *ngIf="canShowModule(module)" [class]="isActive(module.value.ROUTER)"
        (click)="navigateToPage(module.value.ROUTER)" appUserHasRole [allowedRole]="module.value.ALLOWED_ROLE">
        {{ module.key | translate }}
      </span>

    </ng-container>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>